let path = 'http://img.capwhale.com'
let iconShopNav = '/kmc/shopbar/'
let iconImgTextNav = '/kmc/navbar/'

export function iconNavs() { return _iconNavs() }
export function iconNavsSel() { return _iconNavsSel() }
export function iconImgTextNavs() { return _iconImgTextNavs() }
function _iconNavs() {
    let i = 1
    let tmpList = []
    while (i <= 10) {
        let tmp = i < 10 ? `0${i}` : i
        tmpList.push(`${path}${iconShopNav}icon_${tmp}.png`)
        i++
    }
    return tmpList
}
function _iconNavsSel() {
    let i = 1
    let tmpList = []
    while (i <= 10) {
        let tmp = i < 10 ? `0${i}` : i
        tmpList.push(`${path}${iconShopNav}icon_${tmp}_sel.png`)
        i++
    }
    return tmpList
}
function _iconImgTextNavs() {
    let i = 1
    let tmpList = []
    while (i <= 12) {
        let tmp = i < 10 ? `0${i}` : i
        tmpList.push(`${path}${iconImgTextNav}icon_${tmp}.png`)
        i++
    }
    return tmpList
}
